import { supabase } from '../supabase'

import { DEFAULT_MODEL_STACK, isModelStackId, type ModelStackId } from './modelStacks'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000'

export interface RegenerateSummaryResult {
  summary_text: string
  changes: string[]
  programmatic_gates: string[]
}

export async function regenerateProfessionalSummary(params: {
  resumeId: string
  jobDescription: string
  feedback: string[]
  modelStack?: ModelStackId
}): Promise<RegenerateSummaryResult> {
  const {
    data: { session },
  } = await supabase.auth.getSession()
  const headers: Record<string, string> = { 'Content-Type': 'application/json' }
  if (session?.access_token) {
    headers.Authorization = `Bearer ${session.access_token}`
  }

  const stack = params.modelStack && isModelStackId(params.modelStack)
    ? params.modelStack
    : DEFAULT_MODEL_STACK

  const response = await fetch(
    `${API_BASE_URL}/api/v1/optimization/resumes/${params.resumeId}/regenerate-summary`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify({
        job_description: params.jobDescription.trim(),
        feedback: params.feedback,
        model_stack: stack,
      }),
    }
  )

  if (!response.ok) {
    let detail = `Summary regeneration failed (${response.status})`
    try {
      const payload = (await response.json()) as { detail?: string }
      if (payload.detail) detail = payload.detail
    } catch {
      // ignore
    }
    throw new Error(detail)
  }

  return (await response.json()) as RegenerateSummaryResult
}
